import React, { useState, useEffect } from 'react'
import MondayLoader from '../cmps/MondayLoader'
import PermissionAttentionBox from '../cmps/PermissionAttentionBox'
import Button from 'monday-ui-react-core/dist/Button'
import { Add } from 'monday-ui-react-core/dist/allIcons'
import Dropdown from 'monday-ui-react-core/dist/Dropdown'
import boardService from '../services/boardService'
import { useNavigate } from 'react-router-dom'
import { Checkbox, Toast, Tooltip } from 'monday-ui-react-core'

export default function RelationCreator({ sessionToken, userId, user, isEnterprise, loading, setLoading, monday, boards, relations, setRelations, isLoadingBoards }) {
  const [fatherBoardColumns, setFatherBoardColumns] = useState()
  const [fatherBoardConnectColumns, setFatherBoardConnectColumns] = useState()
  const [fatherBoard, setFatherBoard] = useState({})
  const [subBoards, setSubBoards] = useState([])
  const [buttonLoading, setButtonLoading] = useState(false)
  const [hasPermissions, setHasPermissions] = useState(false)
  const [isAddable, setIsAddable] = useState(null)
  const [isMulti, setIsMulti] = useState(false)
  const [countWebhook, setCountWebhook] = useState(0)

  const mirrorOptions = [
    { label: 'on item creation', value: 'create_item' },
    { label: 'on item move to group', value: 'item_moved_to_any_group' },
  ]

  const [mirrorWebhookTrigger, setMirrrorWebhookTrigger] = useState(mirrorOptions[0])
  const navigate = useNavigate()

  useEffect(() => {
    if (!relations) return
    setIsAddable((!isEnterprise && relations.length === 0) || isEnterprise)
  }, [relations, isEnterprise])


  const addBoardsRelations = async () => {
    try {
      setButtonLoading({ add: true })

      const mainRes = await boardService.createNewItemWebHook(Number(fatherBoard?.board?.value), fatherBoard?.column?.value)
      const webhookRes = await boardService.matchGroupAndItemNameWebHook(Number(fatherBoard?.board?.value))
      const mainBoard = { ...fatherBoard, mainWebhook: Number(mainRes), matchGroupAndItemNameWebHookId: Number(webhookRes) }
      setFatherBoard(mainBoard)
      const subBoardIds = subBoards.map((board) => {
        return board.subBoard.value
      })
      const subBoardsRes = []

      for (let i = 0; i < subBoardIds.length; i++) {
        const boardId = subBoardIds[i]
        const subRes = await boardService.createMirrorWebHook(boardId, 'mirrorItemKR', mirrorWebhookTrigger.value, 'subWebhook')
        subBoardsRes.push(subRes)
        setCountWebhook(i + 1)
      }

      const newRelation = await boardService.add(mainBoard, subBoardsRes, userId, user.userDomain, isMulti, sessionToken)
      setRelations([...relations, newRelation])
      setFatherBoard({
        column: { value: null, label: null },
        board: { value: null, label: null },
        connectColumn: { value: null, label: null },
        mainWebhook: null,
      })
      setSubBoards([])
      monday.execute('notice', {
        message: `Relation updated successfuly!`,
        type: 'success',
        timeout: 8000,
      })
      navigate('/controller')
    } catch (err) {
      console.log('file: RelationCreator.jsx:67 -> err:', err)
      monday.execute('notice', {
        message: `Error on creating relation`,
        type: 'error',
        timeout: 8000,
      })
    } finally {
      setButtonLoading(false)
    }
  }

  const onSetFatherBoard = (board) => {
    const dropdown = fatherBoard && getFatherBoardColumns(board?.value)
    setFatherBoard({ board: board, column: dropdown.length ? dropdown : null })
  }

  const onSetChildBoards = (chosenBoards) => {
    if (!chosenBoards) setSubBoards([])
    else if (!chosenBoards.length) return
    else {
      const chosenBoardsArr = chosenBoards?.map((chosenBoard) => {
        return { subBoard: chosenBoard, subWebhook: null }
      })
      setSubBoards(chosenBoardsArr || [])
    }
  }

  const onRemoveChildBoards = (chosenBoard) => {
    const filteredBoards = subBoards?.filter((childBoards) => {
      return childBoards.subBoard.value !== chosenBoard.value
    })

    setSubBoards(filteredBoards || [])
  }

  const getFatherBoardColumns = async (boardId) => {
    if (!boardId) return null
    const query = `query{
          boards(ids:${boardId}){
            columns{
              type
              title
              id
            }
          }
        }`
    const res = await monday.api(query)

    const dropdowns = []
    const connectBoards = []
    res.data.boards[0].columns?.forEach((column) => {
      if (column.type === 'dropdown') {
        dropdowns.push({ value: column.id, label: column.title })
      } else if (column.type === 'board-relation' || column.type === 'board_relation') {
        connectBoards.push({ value: column.id, label: column.title })
      }
    })
    setFatherBoardColumns(dropdowns)
    setFatherBoardConnectColumns(connectBoards)
  }

  const boardNames = boards?.filter((board) => board?.value !== fatherBoard?.board?.value)

  const warningText = () => {

    if (user.license === 'free-trial') return 'Cannot create more than one relation on free trial'
  }

  return (loading && isAddable === null) || !relations ? (
    <MondayLoader />
  ) : (
    <>
      <Toast open={buttonLoading && subBoards?.length > 0} type={Toast.types.NORMAL} onClose={() => setCountWebhook(0)} actions={[]}>
        <p>
          Creating Sub Webhooks: {countWebhook} / {subBoards?.length} ...
        </p>
      </Toast>
      <section>
        <h3>Create new relation</h3>
        {!isAddable && <p className="warning-msg">{warningText()}</p>}
        <div className="content new">
          <div>
            <div className="select-div">
              <span className="select-span">Main board</span>
              <Dropdown className="select" isLoading={isLoadingBoards} noOptionsMessage={() => 'Boards not found'} disabled={!isAddable} placeholder="Choose a main board" value={fatherBoard?.board} options={boardNames} onChange={(board) => onSetFatherBoard(board)} />
            </div>

            <div className="select-div" onClick={() => fatherBoard?.board?.value && getFatherBoardColumns(fatherBoard.board.value)}>
              <span className="select-span">Dropdown</span>
              <Dropdown className="select" disabled={!fatherBoard?.board} noOptionsMessage={() => 'Dropdown columns not found'} placeholder="Choose a dropdown" options={fatherBoardColumns} value={fatherBoard?.column} onChange={(column) => setFatherBoard({ ...fatherBoard, column })} />
            </div>
            <div className="select-div" onClick={() => fatherBoard?.board?.value && getFatherBoardColumns(fatherBoard.board.value)}>
              <span className="select-span">
                Connect <wbr />
                Boards
              </span>
              <Dropdown
                className="select"
                disabled={!fatherBoard?.board}
                noOptionsMessage={() => 'Connect boards columns not found'}
                placeholder="Choose a connect boards column"
                options={fatherBoardConnectColumns}
                value={fatherBoard?.connectColumn}
                onChange={(connectColumn) => setFatherBoard({ ...fatherBoard, connectColumn })}
              />
            </div>

            <div className="select-div">
              <span className="select-span">Sub Boards</span>
              <Dropdown
                className="select"
                multi
                disabled={!fatherBoard?.board}
                placeholder="Choose sub boards"
                value={subBoards?.map((child) => child.subBoard) || null}
                options={boardNames}
                onChange={(board) => onSetChildBoards(board)}
                onOptionRemove={(chosenBoard) => onRemoveChildBoards(chosenBoard)}
              />
            </div>
            <div className="select-div">
              <span className="select-span">Mirror Trigger</span>
              <Dropdown className="select" placeholder="Choose trigger for mirror connection" value={mirrorWebhookTrigger} disabled={!fatherBoard?.board} options={mirrorOptions} onChange={(webhookTrigger) => webhookTrigger && setMirrrorWebhookTrigger(webhookTrigger)} />
            </div>
            <div className="is-multi-checkbox">
              <Tooltip content="The integration will generate groups that will be named also by the item`s group name: {group} ➡{item}">
                <Checkbox label="Groups by {group} ➡ {item}" onChange={() => setIsMulti((isMulti) => !isMulti)} checked={isMulti} />
              </Tooltip>
            </div>
          </div>

          <PermissionAttentionBox subBoards={subBoards?.map((board) => board.subBoard) || []} setHasPermissions={setHasPermissions} />

          <Button
            size={Button.sizes.MEDIUM}
            className="add-button"
            loading={buttonLoading?.add}
            color={Button.colors.PRIMARY}
            disabled={!isAddable || !fatherBoard?.connectColumn || !fatherBoard?.column || !fatherBoard?.board || !subBoards?.map((board) => board.subBoard)?.length || !hasPermissions}
            onClick={addBoardsRelations}
            leftIcon={Add}
          >
            Create relation
          </Button>
        </div>
      </section>
    </>
  )
}
